module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Dark"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-dark"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Info"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-info"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Success"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-success"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Warning"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-warning"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Danger"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-danger"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7aa0434"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/taginput/examples/ExType.vue
// module id = 1259
// module chunks = 7 72